import { useEffect } from 'react';
import { useRouter, NextRouter } from 'next/router';
import { useWebviewCallback } from 'Utils/webviewHandlers';
import { EWebViewActions } from 'Types/index';
import Cookies from 'js-cookie';
import { GARAGE_URL_MAPPING, ROUTEMAP } from '../constants';
import Router from '@/components/common/router';

type CloseWebViewFunction = () => void;

const useCustomBack = (
    shouldCloseWebView: boolean = false,
    backUrl?: string
) => {
    const router: NextRouter = useRouter();
    const isWebView = Boolean(Cookies.get('webview'));

    const redirectToMyAcc = () => {
        window.location.href = '/';
    };
    const handleBack = () => {
        const garageId = localStorage.getItem('garageId');
        if (backUrl === '/') {
            redirectToMyAcc();
            return;
        }
        if (backUrl === '/homepage' && garageId) {
            Router.push(GARAGE_URL_MAPPING[garageId as string]);
        }
        if (backUrl) {
            router.push(backUrl);
            return;
        } else {
            router.back();
        }
    };

    const closeWebView = () => {
        try {
            useWebviewCallback(
                {
                    action: EWebViewActions.CLOSE_WEB_VIEW,
                    action_value: null,
                },
                () => handleBack()
            );
        } catch (e) {
            redirectToMyAcc();
        }
    };

    // useEffect(() => {
    //     const handleBeforePopState = ({ as }: { as: string }) => {
    //         if (shouldCloseWebView) {
    //             console.log('Webview closed');
    //             handleBack();
    //             //closeWebView();
    //             return false;
    //         }
    //         return true;
    //     };

    //     if (isWebView || backUrl === '/') {
    //         router.beforePopState(handleBeforePopState);
    //     }

    //     return () => {
    //         router.beforePopState(() => true);
    //     };
    // }, [router, shouldCloseWebView]);

    return { closeWebView };
};

export default useCustomBack;
